import api from '@/api'

// initial state
const state = {
}

// getters
const getters = {
}

// actions
const actions = {
	meterGetItemById ({ commit, state }, payload) {
		console.log(payload)
		return api.meter.getMeterItemById(payload.data, payload).then(function (data) {
			if (payload.callback && typeof payload.callback === 'function') {
				payload.callback(data)
			}
		})
	},
	meterGetAllMeters ({ commit, state }, payload) {
		console.log(payload)
		return api.meter.getAllMeters(payload.data, payload).then(function (data) {
			if (payload.callback && typeof payload.callback === 'function') {
				payload.callback(data)
			}
		})
	}
}

// mutations
const mutations = {
}

export default {
	state,
	getters,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/meter.js